import React, { useState } from 'react';
import { TabItem, TabList, ContentContainer, ActiveArea } from './styles';

export default function TabSelector({ isReportPage, items, getActiveIndex }) {
  const [active, setActive] = useState(0);
  return (
    <ContentContainer isReportPage={isReportPage}>
      <TabList>
        {items.map((item, index) => (
          <TabItem
            id={item.id}
            key={index}
            active={index === active}
            onClick={() => {
              setActive(index);
              if (getActiveIndex) getActiveIndex(index);
            }}
          >
            {item.label}
          </TabItem>
        ))}
      </TabList>
      <ActiveArea isReportPage={isReportPage}>{items[active].component}</ActiveArea>
    </ContentContainer>
  );
}
